import { FC } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { routes } from "../constants/routes"
import AuthWrapper from "./wrappers/Auth"
import PrivateWrapper from "./wrappers/Private"
import PublicWrapper from "./wrappers/Public"

const wrappers = {
  auth: AuthWrapper,
  private: PrivateWrapper,
  public: PublicWrapper
}

const Router: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {routes.map((route) => {
          const Wrapper = wrappers[route.wrapper]

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <Wrapper>
                  <route.component />
                </Wrapper>
              }
            />
          )
        })}
      </Routes>
    </BrowserRouter>
  )
}

export default Router
